var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup36689(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 25.647C19.6274 25.647 25 20.2744 25 13.647C25 7.01956 19.6274 1.64697 13 1.64697C6.37258 1.64697 1 7.01956 1 13.647C1 20.2744 6.37258 25.647 13 25.647Z",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21.147C9.8433 21.1476 9.19292 21.0188 8.58606 20.7678C7.97904 20.5168 7.42749 20.1485 6.963 19.684C6.49851 19.2195 6.1302 18.6679 5.87916 18.0609C5.62832 17.4544 5.49948 16.8044 5.5 16.1481L10.5 21.147ZM10.5 21.147C9.82329 21.147 9.17705 21.011 8.5872 20.7651C7.97773 20.5109 7.42847 20.1393 6.96805 19.6789C6.50763 19.2185 6.13604 18.6692 5.8819 18.0598C5.63601 17.4701 5.50007 16.824 5.5 16.1475L10.5 21.147ZM14.5 6.16246L14.499 6.14698L14.501 6.14697L14.5 6.16246ZM14.4614 8.14697H14.5H14.5696L14.5155 8.15911L14.4614 8.14697ZM18.5 8.16285L18.4385 8.14697H18.5H18.5615L18.5 8.16285ZM18.501 6.14697L18.5 6.16246L18.499 6.14698L18.501 6.14697ZM10.5 12.8165L10.4991 12.804L10.5009 12.804L10.5 12.819V12.8165ZM5.5 16.1467C5.5 16.1468 5.5 16.1469 5.5 16.147C5.5 16.1469 5.5 16.1468 5.5 16.1467Z",
    fill: "black",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup36689);
export default __webpack_public_path__ + "static/media/Group 36689.e26e1e5c664e7dbd1dc1786809e7ae50.svg";
export { ForwardRef as ReactComponent };